import React from "react";
import { Col, Container, Row } from "react-bootstrap";
//import FaqPageContentForm from "./FaqPageContentForm";
import ContactUsContentForm from "./ContactUsForm";
import { useGetFaqPageContentDetailsQuery } from "../../../../store/services/FaqPageContentService";
import { useGetContactUsContentDetailsQuery } from "../../../../store/services/ContactUsContentService";

function ContactUsContent() {
  const {
    data: pageDetails,
    error,
    isLoading,
  } = useGetContactUsContentDetailsQuery();

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              Contact Us Page Content
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!isLoading && <ContactUsContentForm data={pageDetails?.data} />}
        </Row>
      </Container>
    </section>
  );
}

export default ContactUsContent;
